@ts-nocheck
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">

      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-4">
        <div class="position-relative table-src-form me-0">
        </div>

        <div v-bind:class="{'offcanvas offcanvas-end': true, 'show': isOffcanvasVisible}" tabindex="-1"
             style="min-width: 450px;"
             id="offcanvasRight"
             aria-labelledby="offcanvasRightLabel" v-show="isOffcanvasVisible">
          <div class="offcanvas-header border-bottom p-4">
            <div v-for="(row, index) in list" :key="row.id">
              <div v-if="row.id === vacancyDetail">
                <div
                    :class="[ row.isActive ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger', 'd-inline-block py-1 px-3 rounded-3 mb-3']">
                  <i class="ri-check-line fs-16 position-relative top-1"></i>
                  {{ row.isActive ? 'активная' : 'закрытая' }}
                </div>
                <h3 class="fs-18 fw-medium lh-base lh-sm mb-3">{{ row.title }}</h3>
                <RouterLink :to="`/vacancies/create/${row.id}`">
                  <i class="ri-clipboard-line fs-24 position-relative transition-all hover:text-primary-500 hover:scale-110"
                     title="Копировать вакансию"></i>
                </RouterLink>

                <RouterLink :to="`/candidates/create/${row.vacancyCandidates[0].id}`">
                  <i class="ri-user-add-line fs-24 position-relative transition-all hover:text-primary-500 hover:scale-110"
                     title="Добавить кандидата"
                  ></i>
                </RouterLink>
              </div>
            </div>
            <button type="button" class="btn-close" @click="closeOffcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body p-4">
            <div v-for="(row, index) in list" :key="row.id">
              <div v-if="row.id === vacancyDetail">
                <div v-for="position in row.vacancyCandidates" :key="position.id" class="vacancy-field-item">
                  <div class="card bg-white border-0 rounded-3 mb-4">
                    <div class="card-body p-4">
                      <div class="row">
                        <div class="col-lg-12">

                          <div class="row g-3">
                            <div class="col-md-6 col-lg-4">
                              <!--                              <div v-for="field in fieldsDetails" :key="field.name" class="vacancy-detail-item-"
                                                                 @click="handleCopyField(field, row.position)">-->

                              <div v-for="field in fieldsDetails" :key="field.name" class="vacancy-detail-item">

                                <!-- Position -->
                                <div v-if="field.name === 'position'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Должность:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.position }}</h5>
                                  </div>
                                </div>

                                <!-- Rate -->
                                <div v-else-if="field.name === 'rate'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Ставка:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.rate }} zl</h5>
                                  </div>
                                </div>

                                <!-- Age -->
                                <div v-else-if="field.name === 'age'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Возраст до:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.age }}</h5>
                                  </div>
                                </div>

                                <!-- Schedule -->
                                <div v-else-if="field.name === 'schedule1'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">График:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.schedule1 }}, {{ position.schedule2 }}, {{
                                        position.schedule3
                                      }}</h5>
                                  </div>
                                </div>

                                <!-- Coordinator -->
                                <div v-else-if="field.name === 'coordinatorId'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Координатор:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.coordinator ? row.coordinator.name : 'N/A' }}</h5>
                                  </div>
                                </div>

                                <!-- Coordinator Phone -->
                                <div v-else-if="field.name === 'coordinatorPhone'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Тел. коорд.:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.coordinator ? row.coordinator.phone : 'N/A' }}</h5>
                                  </div>
                                </div>

                                <!-- Quantity Fields -->
                                <div v-else-if="field.name === 'quantity1'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Quantity1:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.quantity1 }}</h5>
                                  </div>
                                </div>
                                <div v-else-if="field.name === 'quantity2'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Quantity2:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.quantity2 }}</h5>
                                  </div>
                                </div>
                                <div v-else-if="field.name === 'quantity3'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Quantity3:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.quantity3 }}</h5>
                                  </div>
                                </div>

                                <!-- Living Exists -->
                                <div v-else-if="field.name === 'livingExists'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Living Exists:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ position.living_exists === 0 ? 'No' : 'Yes' }}</h5>
                                  </div>
                                </div>

                                <!-- Is Active -->
                                <div v-else-if="field.name === 'isActive'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Is Active:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.isActive ? 'Yes' : 'No' }}</h5>
                                  </div>
                                </div>

                                <!-- Is Priority -->
                                <div v-else-if="field.name === 'isPriority'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Is Priority:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.isPriority ? 'Yes' : 'No' }}</h5>
                                  </div>
                                </div>

                                <!-- Is Mediator -->
                                <div v-else-if="field.name === 'isMediator'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Is Mediator:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.isMediator ? 'Yes' : 'No' }}</h5>
                                  </div>
                                </div>

                                <!-- Living Address -->
                                <div v-else-if="field.name === 'living'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Адрес жилья:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2"
                                        style="min-width: 200px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ row.living }}</h5>
                                  </div>
                                </div>

                                <!-- Address -->
                                <div v-else-if="field.name === 'address'">
                                  <div class="d-flex mb-2 align-items-center">
                                    <span class="fw-bold" style="min-width: 150px;">Адрес:</span>
                                    <h5 class="mb-0 fw-medium fs-14 position-relative ms-2">
                                      {{ position.city }}, {{ position.address }}
                                      <a
                                          :href="'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(position.city + ' ' + position.address)"
                                          target="_blank" rel="noopener noreferrer"> (открыть карту)</a>
                                    </h5>
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card bg-white border-0 rounded-3 mb-4">
                    <div class="card-body p-4">
                      <div class="row">
                        <div class="col-lg-12">


                          <div class="row g-3">
                            <div class="col-md-12 col-lg-12"
                                 style="min-width: 300px;  overflow: visible; text-overflow: ellipsis;">
                              {{ position.description }} <br/>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card bg-white border-0 rounded-3 mb-4" v-if="row.comment">
                    <div class="card-body p-4">
                      <div class="row">
                        <div class="col-lg-12">


                          <div class="row g-3">
                            <div class="col-md-12 col-lg-12"
                                 style="min-width: 300px;  overflow: visible; text-overflow: ellipsis;">
                              {{ row.comment }} <br/>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <RouterLink to="/vacancies/create"
                    class="btn btn-outline-primary  px-sm-4 fs-14 fw-medium rounded-3 hover-bg">
                                    <span class="py-sm-1 d-block">
                                        <i class="ri-add-line d-none d-sm-inline-block"></i>
                                        <span>
                                         Добавить вакансию
                                        </span>
                                    </span>
        </RouterLink>
      </div>

      <!-- Custom Alert -->
      <div v-if="deleteAlert.visible" class="custom-alert">
        <div class="alert-content">
          <p class="alert-message">Подтвердите удаление</p>
          <div class="alert-buttons">
            <button
                type="button"
                class="btn btn-danger confirm-button"
                @click="confirmDelete"
            >
              Подтвердить
            </button>
            <button
                type="button"
                class="btn btn-secondary cancel-button"
                @click="cancelDelete"
            >
              Отменить
            </button>
          </div>
        </div>
      </div>

      <div class="default-table-area style-two all-projects">
        <div class="table-responsive">
          <table class="table table-bordered table-striped- table-hover align-middle">
            <thead class="table-light">
            <tr>
              <th v-for="(field, index) in fields" :key="field.name" scope="col">
                <div @click="handleSortClick(field.name)"
                     class="cursor-pointer d-flex justify-content-between align-items-center sortable-header">
                  {{ field.label }}
                  <span class="material-symbols-outlined">{{ getSortIcon(field.name) }}</span>
                </div>
              </th>
              <th scope="col" class="actions-column">Действия</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in list" :key="row.id" :class="getRowClass(row)">
              <td v-for="field in fields" :key="field.name" :class="{'max-width-column': field.name === 'number'}">
                <div class="clickable-column">
                  <div v-if="field.name === 'number'" @click="showDetails(row.id)">
                    {{ row.number }}
                  </div>
                  <div v-else-if="field.name === 'title'" @click="showDetails(row.id)">
                    {{ row.title }}
                  </div>
                  <div v-else-if="field.name === 'city'">
                    <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                      {{ row.vacancyCandidates[0].city }}
                    </div>
                  </div>
                  <div v-else-if="field.name === 'quantity'" style="min-width: 100px;">
                    <div v-for="(position, key) in row.vacancyCandidates" :key="key">
                      <div v-if="userRole==='coordinator_su' || userRole==='coordinator_zl'">
                        <div v-if="position.is_active === 1">
                          <b> М:</b>{{ position.quantity1 > 0 ? position.quantity1 : 0 }}
                          <b> Ж:</b>{{ position.quantity2 > 0 ? position.quantity2 : 0 }}
                          <b> П:</b>{{ position.quantity3 > 0 ? position.quantity3 : 0 }}
                          <br/>
                        </div>
                      </div>
                      <div v-else>
                        <b> М:</b>{{ position.quantity1 > 0 ? position.quantity1 : 0 }}
                        <b> Ж:</b>{{ position.quantity2 > 0 ? position.quantity2 : 0 }}
                        <b> П:</b>{{ position.quantity3 > 0 ? position.quantity3 : 0 }}
                        <br/>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'position'">
                    <div v-for="(position, key) in row.vacancyCandidates" :key="key">
                      <div v-if="userRole==='coordinator_su' || userRole==='coordinator_zl'">
                        <div v-if="position.is_active === 1">
                          <b>{{ position.position }}</b><br/>
                        </div>
                      </div>
                      <div v-else>
                        <b>{{ position.position }} </b><br/>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'rate'">
                    <div v-for="(position, key) in row.vacancyCandidates" :key="key">
                      <div v-if="userRole==='coordinator_su' || userRole==='coordinator_zl'">
                        <div v-if="position.is_active === 1">
                          ({{ position.rate }} zl.) <br/>
                        </div>
                      </div>
                      <div v-else>
                        ({{ position.rate }} zl.) <br/>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'livingExists'" style="width: 100px!important;">
                    <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                      <div v-if="row.vacancyCandidates[0].livingExists == 0">нет</div>
                      <div v-if="row.vacancyCandidates[0].livingExists == 1">
                        {{ row.vacancyCandidates[0].livingPrice }}
                      </div>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'nation'"
                       class="clickable-column">
                    <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                              <span v-for="country in JSON.parse(row.vacancyCandidates[0].nation)" :key="country">
                                <img :src="`/images/flags/${country.slice(0, 3)}.svg`" :alt="country" width="24"
                                     height="16"> &nbsp;
                              </span>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'isArrival'"
                       class="clickable-column">
                    <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                      <span>  {{ row.vacancyCandidates[0].isArrival == '1' ? '' : 'Нет' }}</span>
                      <span v-if="row.vacancyCandidates[0].isArrival == '1'">   {{
                          row.vacancyCandidates[0].arrivalAddress
                        }} </span> <br/>
                      <span v-if="row.vacancyCandidates[0].isArrival == '1'">   {{
                          row.vacancyCandidates[0].arrivalPrice
                        }} zl </span>
                    </div>
                  </div>
                  <div v-else>{{ row[field.name] }}</div>
                </div>
              </td>
              <td class="actions-column">
                <div class="d-flex align-items-center gap-1">
                  <!--                  <button class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                            @click="showDetails(row.id)">
                                      <i class="material-symbols-outlined fs-16 text-primary">visibility</i>
                                    </button>-->

                  <button class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          @click="showDetails(row.id)">
                    <i class="material-symbols-outlined fs-16 text-primary">visibility</i>
                  </button>

                  <a class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                     :href="`/vacancies/edit/${row.id}`">
                    <i class="material-symbols-outlined fs-16 text-body">edit</i>
                  </a>

                  <button class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          v-if="userRole !== 'manager'" v-permission="['vacancy delete']"
                          @click="showDeleteConfirmation(row)">
                    <i class="material-symbols-outlined fs-16 text-danger">delete</i>
                  </button>
                </div>
                <!--                        <div v-if="userRole !== 'recruiter_su' && userRole !== 'recruiter_zl'">
                                          <button class="btn btn-primary btn-sm" @click="handleView(row, 'update')">
                                            <i class="bi bi-pencil-square"></i> Изменить
                                          </button>
                                        </div>
                                        <div v-if="userRole !== 'manager'">
                                          <button class="btn btn-danger btn-sm" v-permission="['vacancy delete']"
                                                  @click="handleDelete(row)">
                                            <i class="bi bi-trash"></i> Удалить
                                          </button>
                                        </div>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--
                <div class="table-responsive">
                  <table class="table align-middle">
                    <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Project Name</th>
                      <th scope="col">Client</th>
                      <th scope="col">Assignees</th>
                      <th scope="col">Budget</th>
                      <th scope="col">Start Date</th>
                      <th scope="col">End Date</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="text-body">
                        {{ item.id }}
                      </td>
                      <td>
                        <RouterLink to="/project-management/project-overview">
                          {{ item.projectName }}
                        </RouterLink>
                      </td>
                      <td>{{ item.client }}</td>
                      <td>
                        <ul class="ps-0 mb-0 list-unstyled d-flex align-items-center">
                          <li
                              class="ms-m-15"
                              v-for="userImg in item.assignees.images"
                              :key="userImg.id"
                          >
                            <RouterLink to="/my-profile">
                              <img
                                  :src="userImg.image"
                                  class="wh-34 lh-34 rounded-circle border border-1 border-color-white"
                                  alt="user"
                              />
                            </RouterLink>
                          </li>
                          <li class="ms-m-15">
                            <RouterLink
                                to="/users/users-list"
                                class="wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                            >
                              {{ item.assignees.number }}
                            </RouterLink>
                          </li>
                        </ul>
                      </td>
                      <td class="text-body">${{ item.budget }}</td>
                      <td class="text-body">
                        {{ item.startDate }}
                      </td>
                      <td class="text-body">
                        {{ item.endDate }}
                      </td>
                      <td>
                          <span
                              class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                              :class="computeClass(item.status)"
                          >
                            {{ item.status }}
                          </span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-1">
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-primary">
                              {{ item.action.view }}
                            </i>
                          </button>
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-body">
                              {{ item.action.edit }}
                            </i>
                          </button>
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-danger">
                              {{ item.action.delete }}
                            </i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
        -->
        <!--
                <div class="table-responsive">
                  <table class="table align-middle">
                    <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Project Name</th>
                      <th scope="col">Client</th>
                      <th scope="col">Assignees</th>
                      <th scope="col">Budget</th>
                      <th scope="col">Start Date</th>
                      <th scope="col">End Date</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="text-body">
                        {{ item.id }}
                      </td>
                      <td>
                        <RouterLink to="/project-management/project-overview">
                          {{ item.projectName }}
                        </RouterLink>
                      </td>
                      <td>{{ item.client }}</td>
                      <td>
                        <ul class="ps-0 mb-0 list-unstyled d-flex align-items-center">
                          <li
                              class="ms-m-15"
                              v-for="userImg in item.assignees.images"
                              :key="userImg.id"
                          >
                            <RouterLink to="/my-profile">
                              <img
                                  :src="userImg.image"
                                  class="wh-34 lh-34 rounded-circle border border-1 border-color-white"
                                  alt="user"
                              />
                            </RouterLink>
                          </li>
                          <li class="ms-m-15">
                            <RouterLink
                                to="/users/users-list"
                                class="wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                            >
                              {{ item.assignees.number }}
                            </RouterLink>
                          </li>
                        </ul>
                      </td>
                      <td class="text-body">${{ item.budget }}</td>
                      <td class="text-body">
                        {{ item.startDate }}
                      </td>
                      <td class="text-body">
                        {{ item.endDate }}
                      </td>
                      <td>
                          <span
                              class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                              :class="computeClass(item.status)"
                          >
                            {{ item.status }}
                          </span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-1">
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-primary">
                              {{ item.action.view }}
                            </i>
                          </button>
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-body">
                              {{ item.action.edit }}
                            </i>
                          </button>
                          <button
                              class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                          >
                            <i class="material-symbols-outlined fs-16 text-danger">
                              {{ item.action.delete }}
                            </i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
        -->


      </div>
    </div>
  </div>
  <!--  vacancy details-->
</template>

<script lang="ts">

// @ts-nocheck
import {fetchList, createVacancy, updateVacancy, deleteVacancy} from '@/api/vacancy';
import {defineComponent, ref, watchEffect, nextTick} from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import axios from 'axios';

export default defineComponent({
  name: "ProjectsList",
  components: {
    Pagination,
  },
  data() {
    return {
      deleteAlert: {
        visible: false,
        row: null,
      },
      isOpen: false,
      isOpen2: false,
      vacancyDetail: null,
      isOffcanvasVisible: false,
      isMobile: false,
      userRole: '',
      user: '',
      tableKey: 0,
      managers: [],
      main_coordinators: [],
      coordinators: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        search: '',
        sort: '',
        is_active: '',
        is_confirmed: '',
      },
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      candidatesToDelete: [],
      candidatesToHide: [],
      temp: {
        //managerId: null,
        //mainCoordinatorId: null,
        //coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogStatus: '',
      dialogPvVisible: false,
      fields: [
        {label: '№', name: 'number', showAsMain: true},
        {label: 'Вакансия', name: 'title', showAsMain: true},
        /*        {label: 'Название', name: 'title', showAsDetails: true},*/
        {label: 'Город', name: 'city', showAsMain: true},
        {label: 'Кол.', name: 'quantity', showAsMain: true},
        {label: 'Должность', name: 'position', showAsMain: true, showAsDetails: true},
        {label: 'Ставка', name: 'rate', showAsMain: true, showAsDetails: true},
        /*      {label: 'Жилье', name: 'livingExists', showAsMain: true},*/
        /*      {label: 'Гражданство', name: 'nation', showAsMain: false},
              {label: 'Доезд', name: 'isArrival', showAsMain: false},
              {label: 'Требуются', name: 'gender', showAsMain: false},*/
        /*        {label: 'Смены', name: 'schedule1'},
                {label: 'Возраст', name: 'age', showAsDetails: true},
                {label: 'График', name: 'schedule1', showAsDetails: true},
                {label: 'Смены', name: 'schedule2'},
                {label: 'Смены', name: 'schedule3'},*/
        /*      {label: 'Пары', name: 'pairs', showAsMain: false},*/
        /*        {label: 'Координатор', name: 'coordinatorId', showAsDetails: true},
                {label: 'Тел. коорд.', name: 'coordinatorPhone', showAsDetails: true},
                {label: 'Количество людей', name: 'quantity1'},
                {label: 'Цена жилья', name: 'livingPrice'},
                {label: 'Адрес жилья', name: 'living', showAsDetails: true},
                {label: 'Адрес', name: 'address', showAsDetails: true},
                {label: 'Смена', name: 'workShift'},
                {label: 'Тип смены', name: 'workShiftType'},
                {label: 'Описание', name: 'description'},
                {label: 'Комментарий', name: 'comment'},
                {label: 'Активная', name: 'isActive'},
                {label: 'Приоритет', name: 'isPriority'},
                {label: 'Для посредников', name: 'isMediator'},
                {label: 'Адрес доезда', name: 'arrivalAddress'},
                {label: 'Цена доезда', name: 'arrivalPrice'},*/
      ],
      fieldsDetails: [
        {label: 'Название', name: 'title', showAsDetails: true},
        {label: 'Должность', name: 'position', showAsMain: true, showAsDetails: true},
        {label: 'Ставка', name: 'rate', showAsMain: true, showAsDetails: true},
        {label: 'Возраст', name: 'age', showAsDetails: true},
        {label: 'График', name: 'schedule1', showAsDetails: true},
        {label: 'Координатор', name: 'coordinatorId', showAsDetails: true},
        {label: 'Тел. коорд.', name: 'coordinatorPhone', showAsDetails: true},
        {label: 'Адрес жилья', name: 'living', showAsDetails: true},
        {label: 'Адрес', name: 'address', showAsDetails: true},
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  methods: {
    toggleSection(section) {
      this.openedSections[section] = !this.openedSections[section];
      // Save state to localStorage
      localStorage.setItem("sidebarState", JSON.stringify(this.openedSections));
    },
    menuItemToggle() {
      this.isOpen = !this.isOpen; // Toggles the `open` class
    },
    menuItemToggle2() {
      this.isOpen2 = !this.isOpen2; // Toggles the `open` class
    },
    showDetails(id) {
      this.vacancyDetail = id;
      this.isOffcanvasVisible = true;
    },
    closeOffcanvas() {
      this.isOffcanvasVisible = false;  // Close the offcanvas
    },
    checkScreenSize() {
      this.isMobile = window.matchMedia("(max-width: 767px)").matches;
      console.log(this.isMobile ? 'This is a mobile screen size.' : 'This is not a mobile screen size.');
    },
    getRowClass(row) {
      console.log('row:', row.isPriority);
      return row.isPriority ? 'priority-row' : '';
      //return 'priority-row1';
    },
    updateMainCoordinators() {
      // Filter main_coordinators based on selected manager
      // const manager = this.managers.find(
      //   (m) => m.id === this.temp.managerId
      // );
      // this.main_coordinators = this.main_coordinators.filter(
      //   (c) => c.owner_id === (manager ? manager.id : null)
      // );

      // Reset dependent fields
      this.temp.mainCoordinatorId = null;
      this.temp.coordinatorId = null;
      //this.coordinators = [];
    },
    updateCoordinators() {
      // Filter coordinators based on selected main_coordinator
      // const mainCoordinator = this.main_coordinators.find(
      //   (mc) => mc.id === this.temp.mainCoordinatorId
      // );
      // this.coordinators = this.coordinators.filter(
      //   (c) => c.owner_id === (mainCoordinator ? mainCoordinator.id : null)
      // );

      // Reset dependent field
      this.temp.coordinatorId = null;
    },
    setCoordinatorPhone(e) {
      let coordFind = this.coordinators.find(u => u.id === e);
      this.temp.coordinatorPhone = coordFind.phone;
    },
    addCandidate() {

    },
    addCandidateRow() {
      this.temp.candidates.push(
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
      );
    },
    setCandidateStatus(candidate, status) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        this.temp.candidates[index].isActive = status;
      } else {
        console.error("Candidate not found");
      }
    },
    deleteCandidateRow(candidate) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        // If candidate has an ID, add it to the candidatesToDelete array
        if (candidate.id) {
          this.candidatesToDelete.push(candidate.id);
        }
        this.temp.candidates.splice(index, 1);  // Remove candidate from the list
      }
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);

      if (match && match[1]) {
        if (parseInt(match[1]) === 1) {
          this.listQuery.is_active = 1;
          this.listQuery.is_confirmed = 1;
        } else if (parseInt(match[1]) === 0) {
          this.listQuery.is_active = 0;
          this.listQuery.is_confirmed = 1;
        } else if (parseInt(match[1]) === 2) {
          this.listQuery.is_active = 1;
          this.listQuery.is_confirmed = 0;
        }
      } else {
        this.listQuery.is_active = this.$route.query.status || null;
      }
      if (this.$route.query['main-search']) {
        this.listQuery.search = this.$route.query['main-search'];
      }
    },
    setRules() {
      return {
        // number: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        title: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // position: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rate: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateFrequency: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateUnit: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // schedule1: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // city: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // gender: [{type: 'array', required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // //quantity: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // livingExists: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // age: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // address: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShift: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShiftType: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //isArrival: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //description: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      console.log('getting list');
      this.listLoading = true;
      this.parseStatusFromUrl();
      const data = await fetchList(this.listQuery);
      if (data.redirect_to) {
        window.location.href = data.redirect_to;
      }
      this.list = data.vacancies.items.map(vacancy => {
        if (vacancy.vacancyCandidates && Array.isArray(vacancy.vacancyCandidates)) {
          // Add description_old for each vacancyCandidate
          vacancy.vacancyCandidates.forEach(candidate => {
            candidate.description_old = candidate.description;
          });
        }
        return vacancy;
      });

      //console.log(this.list);
      this.total = data.vacancies.total;
      this.userRole = data.userRole;

      this.managers = data.managers;
      this.main_coordinators = data.mainCoordinators;
      this.coordinators = data.coordinators;

      this.user = data.user;

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }

      this.listLoading = false;
    },
    handleFilter() {
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        localStorage.removeItem('searchQuery');
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        localStorage.setItem('searchQuery', searchQuery);
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: 'Successful operation',
        type: 'success',
      });
      row.status = status;
    },
    handleSortClick(field) {
      // Prevent sorting for 'rate' & 'quantity' but still show icons
      if (field === 'rate' || field === 'quantity') return;

      this.sortChange(field);
    },
    sortChange(field) {
      if (this.listQuery.sort === '+' + field) {
        this.listQuery.sort = '-' + field; // Toggle to descending
      } else {
        this.listQuery.sort = '+' + field; // Toggle to ascending
      }
      this.handleFilter();
    },
    getSortIcon(field) {
      if (this.listQuery.sort === '+' + field) {
        return "arrow_drop_up"; // Ascending icon
      } else if (this.listQuery.sort === '-' + field) {
        return "arrow_drop_down"; // Descending icon
      }
      //return "unfold_more"; // Default (no sorting applied)
    },
    resetTemp() {
      this.temp = {
        managerId: null,
        mainCoordinatorId: null,
        coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      };

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    formatErrors(errors) {
      let formattedErrors = '';
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          formattedErrors += `${errors[key].join(', ')}\n`;
        }
      }
      return formattedErrors;
    },
    formatServerError(response) {
      let formattedError = `Статус: ${response.status} ${response.statusText}\n`;
      if (response.data && response.data.message) {
        formattedError += `Сообщение: ${response.data.message}\n`;
      }
      if (response.data && response.data.errors) {
        formattedError += this.formatErrors(response.data.errors);
      }
      return formattedError;
    },
    handleRowRightClick(row, column, event) {
      if (this.userRole !== 'recruiter_su' && this.userRole !== 'recruiter_zl') {
        event.preventDefault();
        this.handleView(row, 'edit');
      }
    },
    handleView(row, mode) {
      console.log(row);

      // Deep clone the row object
      this.temp = JSON.parse(JSON.stringify(row));

      // Ensure reactivity by setting temp.candidates to a reactive array
      this.$set(this.temp, 'candidates', this.temp.vacancyCandidates.map(candidate => {
        // Parse nation field of each candidate
        let parsedCandidate = {
          ...candidate,
          nation: JSON.parse(candidate.nation)
        };
        return parsedCandidate;
      }));

      // Set dialog properties
      this.dialogStatus = mode;
      this.dialogFormVisible = true;

      // Clear validation
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    showDeleteConfirmation(row) {
      this.deleteAlert.row = row;
      this.deleteAlert.visible = true;
    },
    confirmDelete() {
      const row = this.deleteAlert.row;
      if (row) {
        deleteVacancy(row).then(() => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
          this.cancelDelete();
        });
      }
    },
    cancelDelete() {
      this.deleteAlert.visible = false;
      this.deleteAlert.row = null;
    },

    handleDelete(row) {
      /*  deleteVacancy(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });*/
    },
    handleImage(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          this.temp.images.push(e.target.result);
        };
      }
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    deleteImage(index) {
      this.temp.images.splice(index, 1);
    },
    openImageInNewTab(image) {
      const url = image.startsWith('http') ? image : `${window.location.origin}/${image}`;
      window.open(url, '_blank');
    },
    handleCopyField(field, row, living = null) {
      let textToCopy = '';
      switch (field.name) {
        case 'gender':
          textToCopy = '' + row.gender.join(', ');
          break;
        case 'schedule1':
          textToCopy = '' + row.schedule1;
          if (row.schedule2 && row.schedule2 !== 'null') {
            textToCopy += ', ' + row.schedule2;
          }
          if (row.schedule3 && row.schedule3 !== 'null') {
            textToCopy += ', ' + row.schedule3;
          }
          break;
        case 'coordinatorId':
          textToCopy = '' + (row.coordinator ? row.coordinator.name : '');
          break;
        case 'coordinatorPhone':
          textToCopy = '' + (row.coordinator ? row.coordinator.phone : '');
          break;
        case 'quantity1':
          textToCopy = '' + row.quantity1;
          break;
        case 'quantity2':
          textToCopy = '' + row.quantity2;
          break;
        case 'quantity3':
          textToCopy = '' + row.quantity3;
          break;
        case 'living':
          textToCopy = '' + living
          break;
        case 'livingExists':
          textToCopy = '' + (row.livingExists === 0 ? 'No' : 'Yes');
          break;
        default:
          textToCopy = row[field.name];
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              console.log('Text copied to clipboard: ', textToCopy);
            })
            .catch(err => {
              console.error('Failed to copy text: ', err);
            });
      } else {
        // Fallback method
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            console.log('Text copied to clipboard: ', textToCopy);
          } else {
            console.error('Failed to copy text');
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    handleCopyText(row, vacancy) {
      let scheduleText = row.schedule1;
      if (row.schedule2 && row.schedule2 !== 'null') {
        scheduleText += ' ' + row.schedule2;
      }
      if (row.schedule3 && row.schedule3 !== 'null') {
        scheduleText += ' ' + row.schedule3;
      }

      const textToCopy =
          'Название: ' + vacancy + '\n\n' +
          'Должность: ' + row.position + '\n\n' +
          'Cтавка: ' + row.rate + '\n\n' +
          'Возраст: ' + row.age + '\n\n' +
          'График: ' + scheduleText + '\n\n' +
          'Описание: ' + row.description;

      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      //textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.log('Text copied to clipboard');
        } else {
          console.error('Failed to copy text');
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    },
    handleCopy(data) {
      this.resetTemp();
      this.temp = data
      this.temp.id = null;
      this.temp.images = [];
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    toggleRowExpansion(row) {
      this.$refs.elTable.toggleRowExpansion(row);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    loadSearchTerm() {
      this.listQuery.search = localStorage.getItem("searchTerm") || ""; // Load from local storage
    },
    handleStorageChange(event) {
      if (event.key === "searchTerm") {
        this.searchTerm = event.newValue; // Update search term when local storage changes
        this.getList();
      }
    },
    startStoragePolling() {
      // Poll local storage for changes every 500ms
      this.storagePollingInterval = setInterval(() => {
        const currentSearchTerm = localStorage.getItem("searchTerm") || "";
        if (currentSearchTerm !== this.listQuery.search) {
          this.listQuery.search = currentSearchTerm; // Update search term
          this.getList(); // Perform search
        }
      }, 500);
    },
    stopStoragePolling() {
      // Clear the polling interval
      if (this.storagePollingInterval) {
        clearInterval(this.storagePollingInterval);
      }
    },
  },
  async mounted() {
    try {
      this.loadSearchTerm(); // Load initial search term
      this.startStoragePolling(); // Start polling local storage
      this.getList(); // Fetch initial data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
  beforeDestroy() {
    this.stopStoragePolling(); // Clean up polling interval
  },
  setup() {
    const wordConfirmed = ref("Finished");
    const wordInProgress = ref("In Progress");
    const wordPending = ref("Pending");

    const computeClass = (classValue: string) => {
      return {
        confirmed: wordConfirmed.value === classValue,
        inProgress: wordInProgress.value === classValue,
        pending: wordPending.value === classValue,
      };
    };

    return {
      computeClass,
    };
  },
  watch: {
    '$route'(to, from) {
      this.getList();
    }
  },
});
</script>

<style lang="scss" scoped>
/* Make header clickable */
.sortable-header {
  cursor: pointer;
}

/* Hover effect */
.sortable-header:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Sort icon styles */
.sort-icon {
  font-size: 20px;
  margin-left: 8px;
}

.custom-alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  width: 100%;
}

.alert-content {
  text-align: center;
}

.alert-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

/* Table styles */
.default-table-area {
  width: 100%;
  overflow-x: auto; // Allow horizontal scrolling if necessary

  .table-responsive {
    width: 100%;
    overflow-x: auto; // Ensure the table is scrollable horizontally

    .table {
      width: 100%;
      table-layout: fixed; // Ensure the table layout is fixed

      th,
      td {
        white-space: nowrap; // Prevent text from wrapping
        overflow: hidden; // Hide overflow
        text-overflow: ellipsis; // Add ellipsis for overflow text
      }

      .actions-column {
        width: 120px; // Fixed width for actions column
        /*    text-align: center; // Center align the buttons*/
      }

      tbody {
        tr {
          td {
            ul {
              li {
                &.ms-m-15 {
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.max-width-column {
  max-width: 10px; // Set your desired maximum width
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Additional styles for clickable columns */
.clickable-column {
  cursor: pointer;
}

.clickable-column:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Ensure buttons are always visible */
.actions-column {
  button {
    margin: 0 5px; // Add spacing between buttons
    padding: 5px 10px; // Add padding for better clickability
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  button:hover {
    opacity: 0.9;
  }


}

/* Icon styling */
.transition-all {
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.transition-all:hover {
  background-color: #f0f0f0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Optional: If you want outlined version */
.ri-clipboard-line,
.ri-user-add-line {
  stroke: currentColor;
  stroke-width: 1.5px;
}
</style>

<style>
.priority-row {
  border-left: 2px solid blue !important;
}

</style>
